import { Cancel, Chromecast } from 'iconoir-react';

export const ModalDevices = ({ isOpen, onClose, devices = [] }) => {
  if (!isOpen) return null;

  const count = Array.isArray(devices) ? devices.length : 0;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-2"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-md w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="relative flex items-center justify-center px-4 py-4 border-b border-gray-100">
          <h4 className="flex items-center mb-0 gap-2 text-center font-semibold text-gray-800 px-10">
            <Chromecast className="w-6 h-6 flex-shrink-0" />
            Dispositivos conectados ({count})
          </h4>
          <button
            onClick={onClose}
            aria-label="Cerrar"
            className="absolute right-4 text-gray-600 px-2 text-xl leading-none hover:text-gray-800"
          >
            <Cancel className="w-5 h-5" />
          </button>
        </div>


        {/* Device list */}
        <div className="py-4 px-3 max-h-[60vh] overflow-y-auto space-y-2">
          {count > 0 ? (
            devices.map((d, idx) => {
              const hostname = d.HostName || d.hostName || d.name || 'Dispositivo desconocido';
              const ip = d.HostIPAddress || d.hostIP || d.ip || '—';

              return (
                <div
                  key={idx}
                  className="flex items-center gap-3 p-3 rounded-xl bg-gray-50 border border-gray-100 hover:border-purple-200 hover:bg-purple-50/30 transition-colors"
                >
                  <div className="bg-purple-50 border border-gray-200 text-colorprimary rounded-lg w-9 h-9 flex items-center justify-center flex-shrink-0 font-bold text-sm">
                    {idx + 1}
                  </div>
                  <div className="flex-1 min-w-0">
                      <span className="flex text-md font-medium text-gray-800 truncate leading-tight">{hostname}</span>
                      <span className="flex text-sm text-gray-500 truncate mt-0.5">IP: {ip}</span>
                    </div>
                </div>
              );
            })
          ) : (
            <div className="flex flex-col items-center justify-center py-10 gap-2 text-gray-400">
              <svg className="w-10 h-10 opacity-30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M1.42 9a16 16 0 0 1 21.16 0" />
                <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                <path d="M10.17 15.65a5.5 5.5 0 0 1 3.71 0" />
                <circle cx="12" cy="20" r="1" />
              </svg>
              <p className="text-sm">No se encontraron dispositivos</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
